import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { posthog } from '../lib/posthog';
/**
 * Tracks a $pageview event in PostHog every time the route changes.
 * Mount this once inside <BrowserRouter> in AppRouter.tsx.
 */
export function PostHogPageviewTracker() {
  const location = useLocation();
  useEffect(() => {
    if (typeof posthog?.capture === 'function' && (posthog as any).__loaded) {
      posthog.capture('$pageview', {
        $current_url: window.location.href,
        path: location.pathname
      });
    }
  }, [location.pathname, location.search]);
  return null;
}